import { useSelector } from 'react-redux';
import { filter } from 'lodash';
import React, { useEffect, useState } from 'react';
import { map } from 'lodash';
import { useHistory } from 'react-router-dom';
import { SHARE_PLACE_ROUTE } from '../router/routes';
import { Button } from '../utils/forms/Button';
import ReservationsList from '../Reservations/ReservationsList';

export default function PermanentPlacesList({ reservationTitle, place }) {
  const [rolled, setRoll] = useState(false);
  const history = useHistory();
  function handleToggle() {
    setRoll(!rolled);
  }
  function handleSharePlace(place) {
    history.push(SHARE_PLACE_ROUTE.replace(':spotId', place.placeId), place);
  }

  return (
    <div className={`permanent-places${rolled ? ' rolled' : ''}`}>
      <span className="permanent-places-reservation-title">
        {reservationTitle}
      </span>
      <Button
        type="button"
        color="share-place"
        onClick={() => handleSharePlace(place)}
      >
        <i className="far fa-share-square ml1" />
      </Button>
      <div className="card">
        <div className="card__body">
          <div className="card__row">
            <div>
              <i className="fas fa-map-pin" />
              <span className="card__row--label ml1">{place.address}</span>
            </div>
            <div>
              <i className="fas fa-map-marker-alt" />
              <span className="ml1">{reservationTitle}</span>
            </div>
            <div>
              <i className="fas fa-grip-lines" />
              <span className="card__row--label ml1">Patro</span>
              <span className="ml1">{place.floor}</span>
            </div>
            <div>
              <div className="permanent-places__toggle" onClick={handleToggle}>
                Historie
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="permanent-places__body">
        <table>
          <thead>
            <tr>
              <th>Číslo</th>
              <th>Datum</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {map(place.shares, (share, id) => {
              return (
                <tr key={id} className="permanent-places-card__details">
                  <td>{id + 1}</td>
                  <td>
                    &nbsp;
                    <i className="far fa-calendar" />
                    <span>Datum</span>
                    {`${share.dateFrom} - ${share.dateTo}`}
                  </td>
                  <td>
                    {share.shareState === 'ACCEPTED'
                      ? 'POTVRZENO'
                      : 'ČEKÁ NA POTVRZENÍ'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
